<template>
  <div>
    <div id="modalEncryptionPdf" class="modal">
      <!-- Modal content -->
      <div class="modal-content">
        <div class="modal-content-header">
          <h3>Senha PDF</h3>
          <span class="close" @click="closeModal">&times;</span>
        </div>
        <div class="modalEncryptionPdf-body">
          <p>Copie a senha abaixo e insira ao abrir o PDF.</p>
          <div class="inputs">
            <input
              id="modalEncryptionPdf-password"
              value=""
              class="form-control"
              disabled
            />
            <button id="modalEncryptionPdf-button" @click="copyValue()">
              Copiar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modalEncryptionPdf',
  data() {
    return {}
  },
  methods: {
    closeModal() {
      const modalEncryptionPdf = document.getElementById('modalEncryptionPdf')
      modalEncryptionPdf.style.display = 'none'
    },
    copyValue() {
      const modalEncryptionPdfPassword = document.getElementById(
        'modalEncryptionPdf-password'
      )
      navigator.clipboard.writeText(modalEncryptionPdfPassword.value)

      const modalEncryptionPdfButton = document.getElementById(
        'modalEncryptionPdf-button'
      )
      modalEncryptionPdfButton.textContent = 'Copiado!'
      modalEncryptionPdfButton.style.background = 'green'
    },
  },
}
</script>

<style lang="scss" scoped>
#modalEncryptionPdf {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 99999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  /* Modal Content/Box */
  .modal-content {
    background-color: #fefefe;
    margin: 15% auto; /* 15% from the top and centered */
    padding: 20px;
    border: 1px solid #888;
    width: 30%; /* Could be more or less, depending on screen size */

    .modal-content-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      h3 {
        font-size: 18px;
        margin-bottom: 0;
        font-weight: 700;
      }
    }

    .modalEncryptionPdf-body {
      p {
        margin-top: 10px;
        margin-bottom: 5px;
      }
      .inputs {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 0 15px 0;
        gap: 10px;

        button {
          background: #aaa;
          color: #fff;
          padding: 0 10px;
          height: 38px;
        }
      }
    }
  }

  /* The Close Button */
  .close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
    text-align: right;
  }

  .close:hover,
  .close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
  }
}
</style>
